// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"2326bb00","284":"8b82634f","453":"0cded454","519":"f1811c6e","528":"c10b78d7","718":"0b5d00cf","879":"58bf6e1b","897":"257a4e34","915":"bb8b9791"}[chunkId] + ".chunk.js";
};